import { Component } from '@angular/core';

@Component({
  selector: 'app-connectivity',
  templateUrl: './connectivity.component.html'
})
export class ConnectivityComponent {
}
